/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiChartCrawler;
(function (ApiChartCrawler) {
    ApiChartCrawler["NO_CRAWLERS"] = "NO_CRAWLERS";
    ApiChartCrawler["ONLY_CRAWLERS"] = "ONLY_CRAWLERS";
    ApiChartCrawler["WITH_CRAWLERS"] = "WITH_CRAWLERS";
})(ApiChartCrawler || (ApiChartCrawler = {}));
export function ApiChartCrawlerFromJSON(json) {
    return ApiChartCrawlerFromJSONTyped(json, false);
}
export function ApiChartCrawlerFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiChartCrawlerToJSON(value) {
    return value;
}
